import React, { useRef, useEffect } from "react";
import { Box, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import ShareIcon from "@mui/icons-material/Share";
import ExpandedTalentList from "./ExpandedTalentList";
import SharePopup from "./SharePopup";
import NoticePreviewDialog from "../NoticePreviewDialog";

const SubmissionTable = ({
  submissions,
  expandedList,
  fetchTalentDetails,
  talentDetails,
  isLoading,
  favorites,
  setFavorites,
  notes,
  setNotes,
  editingNote,
  setEditingNote,
  noteText,
  setNoteText,
  handleFavouriteClick,
  handleMoveTalent,
  sortBy,
  setSortBy,
  handleMessageClick,
  navigate,
  shareMenuRef,
  sharePos,
  showShareMenu,
  getShareLinks,
  handleShare,
  moveStatus,
  setMoveStatus,
  setTalentDetails,
  toggleSelection,
  selectedTalents,
  shareNotice,
  noticeId
}) => {
  const [noticeDialogOpen, setNoticeDialogOpen] = React.useState(false);
  const [selectedNotice, setSelectedNotice] = React.useState(null);
  const [activeListCell, setActiveListCell] = React.useState(null);
const expandedRef = useRef(null);

  const listLabels = [
    { key: "newUserIds", label: "New" },
    { key: "aListUserIds", label: "A List" },
    { key: "bListUserIds", label: "B List" },
    { key: "cListUserIds", label: "C List" },
    { key: "xListUserIds", label: "X List" }
  ];
useEffect(() => {
  if (expandedList.roleId && expandedRef.current) {
    expandedRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }
}, [expandedList]);
  return (
    <Box mt={4}>

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ textAlign: 'center' }}><strong>Role</strong></TableCell>
              {/* <TableCell><strong>Actions</strong></TableCell> */}
              {listLabels.map(({ label }) => (
                <TableCell sx={{ textAlign: 'center' }} key={label}><strong>{label}</strong></TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {submissions.map((roleRow, index) => (
              <TableRow key={index}>
                <TableCell sx={{ textAlign: 'center' }}><strong>{roleRow.roleTitle}</strong></TableCell>
                {/* <TableCell>
        <button
          onClick={() => {
            setSelectedNotice({
              noticeId,
              projectTitle: roleRow.projectTitle || roleRow.roleTitle
            });
            setNoticeDialogOpen(true);
          }}
          className="bg-blue-100 text-blue-800 font-medium py-1 px-3 rounded mr-2"
        >
          View Notice
        </button>
        <IconButton onClick={(e) => handleShare(e, roleRow)}>
          <ShareIcon />
        </IconButton>
      </TableCell> */}

                {listLabels.map(({ key, label }) => {
const userIds = Array.isArray(roleRow[key]) ? roleRow[key] : [];
const count = userIds.length;
                  const isActive = activeListCell?.roleId === roleRow.roleId && activeListCell?.listName === label;

                  return (
                    <TableCell
                      key={label}
                      style={{
                        cursor: count > 0 ? "pointer" : "default",
                        color: count > 0 ? "#007bff" : undefined,
                        textAlign: "center"
                      }}
                      onClick={() => {
                        if (count > 0) {
                          setActiveListCell({ roleId: roleRow.roleId, listName: label });
                          fetchTalentDetails(label, userIds.join(","), roleRow.roleId, label);
                        }
                      }}
                    >
                      <span
                        style={{
                          display: "inline-block",
                          width: "40px",
                          height: "40px",
                          lineHeight: "40px",
                          borderRadius: "50%",
                          backgroundColor: isActive ? "#eee" : "transparent",
                          fontWeight: "bold"
                        }}
                      >
                        {count}
                      </span>
                    </TableCell>
                  );
                })}

              </TableRow>
            ))}

            {/* ⬇ Expanded list row rendered once, after all rows */}
{expandedList.roleId && (
  <TableRow ref={expandedRef} sx={{ backgroundColor: "#eee" }}>
    <TableCell colSpan={listLabels.length + 2}>
                  <ExpandedTalentList
                    currentListName={expandedList.listName}
                    talentDetails={talentDetails}
                    isLoading={isLoading}
                    favorites={favorites}
                    notes={notes}
                    editingNote={editingNote}
                    setEditingNote={setEditingNote}
                    noteText={noteText}
                    setNoteText={setNoteText}
                    sortBy={sortBy}
                    setSortBy={setSortBy}
                    setFavorites={setFavorites}
                    setNotes={setNotes}
                    setMoveStatus={setMoveStatus}
                    moveStatus={moveStatus}
                    setTalentDetails={setTalentDetails}
                    userId={localStorage.getItem("userId")}
                    navigate={navigate}
                    setIsReplyDrawerOpen={() => { }}
                    setSelectedMessage={() => { }}
                    handleMessageClick={handleMessageClick}
                    handleMoveTalent={handleMoveTalent}
                    handleFavouriteClick={handleFavouriteClick}
                    toggleSelection={toggleSelection}
                    selectedTalents={selectedTalents}
                    submissions={submissions}
                  />
                </TableCell>
              </TableRow>
            )}
          </TableBody>

        </Table>
      </TableContainer>
      <NoticePreviewDialog
        open={noticeDialogOpen}
        onClose={() => setNoticeDialogOpen(false)}
        notice={selectedNotice}
      />
    </Box>
  );
};

export default SubmissionTable;